import { Heading } from 'native-base';
import React, { memo } from 'react';
const HEADING = `Summary`;
const SummaryHeader = () => {
  return /*#__PURE__*/React.createElement(Heading, {
    color: "primary.400",
    fontSize: {
      base: 'xl',
      md: '2xl',
      lg: '3xl'
    },
    accessibilityLabel: HEADING,
    accessibilityRole: "header"
  }, HEADING);
};
export default /*#__PURE__*/memo(SummaryHeader);
//# sourceMappingURL=index.js.map